// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_3j8X9D-sm-b6b_WmXtLm3S","title":"_3n354LvekHsDBFOM9UetK_","info":"_2z0MAGcw6Zy2EHW-dI1qD2","label":"_2obmoEwDzS047L0F5O7uhB","buttonSection":"_1bM_vQnJrxjvTtQbLr_3c-"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Journal/components/DeleteNote.mod.css
// module id = 1131
// module chunks = 0